import React from 'react';

/**
 * Modern Badge Component
 * Status badges with gradient backgrounds
 */
export const ModernBadge = ({ 
  children, 
  variant = 'default',
  size = 'md' 
}) => {
  const variants = {
    default: 'bg-slate-500/20 text-slate-400 border-slate-500/20',
    success: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
    warning: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
    danger: 'bg-red-500/20 text-red-400 border-red-500/30',
    info: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
    pending: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
  };

  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-1.5 text-base',
  };

  return (
    <span className={`${variants[variant]} ${sizes[size]} rounded-full font-medium border backdrop-blur-sm`}>
      {children}
    </span>
  );
};

// Helper function to get badge variant from status
export const getStatusVariant = (status) => {
  const statusMap = {
    'Completed': 'success',
    'Complete': 'success',
    'In Progress': 'info',
    'Pending': 'pending',
    'Not Started': 'default',
    'On Hold': 'warning',
    'Failed': 'danger',
    'Error': 'danger',
  };
  return statusMap[status] || 'default';
};

export default ModernBadge;

